import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useIsMobile } from 'hooks/useIsMobile';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { decodeStorage } from 'functions/storageBase64';
import {ModalLoadingCredit} from 'components/Loading';
import { useStorage64 } from 'hooks/useStorageBase64';


export function LineaTelmex() {

    const history = useHistory();
    const { isMobile } = useIsMobile();
    const profileData = decodeStorage('profileData');

    const EXTERNO = decodeStorage('EXTERNO');

    const [, setInfoLineaTelmexStorage] = useStorage64('infoLineaTelmexStorage', '');

    //respuestas servicios
    const [ loading, setLoading ] = useState(false);


    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Linea telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])

    //Con linea Telmex
    const handleIrLineaTelmexButton = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}con-linea-telmex`);
    };

    //Ir a verificar-identidad y depues claroscore
    const handleConsultarClaroScore = () => {
        setLoading(true);  
        //se guarda variable en el storage para detectar que no tiene linea telmex, y se manda verificacion OTP"
        setInfoLineaTelmexStorage({
            "LineaTelmex": false,
        })
        history.push(`${BASE_PATH}${SUB_DIRECTORY}verificar-identidad`);
    }


    return (
        <> 
            { loading && <ModalLoadingCredit /> }
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
            {
                EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
            }
                <main>
                    <div class="boxUlRazones">
                        <h1 className='bold fontsize18 texto'>¿Cuentas con una linea Telmex?</h1>
                        <ul>
                            <li onClick={handleIrLineaTelmexButton}>
                                <span class="nombreRazon">Si tengo linea Telmex</span>
                                <span class="iconoRazon"></span>
                            </li>
                            <li onClick={handleConsultarClaroScore}>
                                <span class="nombreRazon">No tengo linea Telmex</span>
                                <span class="iconoRazon"></span>
                            </li>
                        </ul>
                    </div>
                </main>
            </div>
        </>
    )
}